'use client';
import Image from 'next/image';
import Slider, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const BrowseImageSlider = ({ urls }: { urls: string[]; platform?: string }) => {
  const settings: Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    // dotsClass: 'slick-dots slick-thumb ' + platform,
  };

  // if (platform === 'desktop') {
  //   settings.customPaging = (i) => {
  //     return (
  //       <Image
  //         width={60}
  //         height={40}
  //         src={urls[i]}
  //         alt=""
  //         className="w-[60px] h-[41px] dark:invert dark:brightness-75"
  //       />
  //     );
  //   };
  // }

  return (
    <Slider {...settings}>
      {urls.map((url) => (
        <div key={url} className="border rounded-lg overflow-hidden">
          <Image
            width={992}
            height={992}
            className="dark:invert-[90] dark:hue-rotate-180"
            src={url}
            alt={url}
            sizes="(max-width: 1200px) 100vw, 992px"
            unoptimized
          />
        </div>
      ))}
    </Slider>
  );
};

export default BrowseImageSlider;
